export const UserTypes = {
  IAuthService: Symbol("IAuthService"),
};
